// extracted by mini-css-extract-plugin
export var validateFileStepCell = "validate-file-step__cell_qGkm2eplyDiuTSCADXNY";